module.exports = __webpack_public_path__ + "assets/images/service-7.37c856b3.png";


//////////////////
// WEBPACK FOOTER
// ./imgs/service-7.png
// module id = 181
// module chunks = 0